var productCardMarkup = `
 <div class="w-list-wrap">
 {{#products}}
        
       <div  class="w-item">
        <a href="{{du}}">
         <img  class="grid-view-item__image lazyautosizes" src="{{iu}}" />
         </a>
         <a class="title" href="{{du}}">{{dt}} - <span>{{variantinfo}}</span></a>
         <div class="price">$ {{pr}}</div>
         <a class="choose" href="{{du}}">CHOOSE YOUR SIZE</a>
          <a href="" data-product-id="{{empi}}" data-url="{{du}}" data-directadd="{{epi}}" class="btn-round">
			{{#isInCart}}ADD TO CART{{/isInCart}} 
			{{^isInCart}}ADD TO CART{{/isInCart}}
		</a>
		<div class="delete"><a href="" data-price="{{pr}}" data-varient-da="{{variantinfo}}" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="remove-w-item">REMOVE FROM BAG</a></div>		
			
       </div>
        
        
  {{/products}}
 </div>
`;

function getVariantInfo(variants){
    try {
        let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []) , variantinfo;
        if(variantKeys.length > 0){
            variantinfo = variantKeys[0];
            if(variantinfo == "Default Title"){
                variantinfo = "";
            }
        } else {
            variantinfo = "";
        }
        return variantinfo;
    } catch(err){
        return variants;
    }
}

function swymCallbackFn(){
    // gets called once Swym is ready
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    _swat.fetchWrtEventTypeET(
        function(products) {
            // Get wishlist items
            var formattedWishlistedProducts = products.map(function(p){
                p = SwymUtils.formatProductPrice(p);    // formats product price and adds currency to product Object
                p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
                p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
                return p;
            });

            var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {products: formattedWishlistedProducts});
            wishlistContentsContainer.innerHTML = productCardsMarkup;

            attachClickListeners();

        },
        window._swat.EventTypes.addToWishList
    );
}


if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);


function onAddToCartClick(e){
    e.preventDefault();
    var productId = e.target.getAttribute("data-product-id");
    var variantId = e.target.getAttribute("data-variant-id");
 
    var du = e.target.getAttribute("data-url");
    e.target.innerHTML = "Adding..";
    window._swat.replayAddToCart(
        {empi: productId, du: du},
        variantId,
        function() {
            e.target.innerHTML = "Moved to cart";
            window.location.reload();
            console.log("Successfully added product to cart.");
        },
        function(e) {
            console.log(e);
        }
    );
}


function onremoveItemClicked(e){
    e.preventDefault();
    var productId = e.target.getAttribute("data-product-id");
    var variantId = e.target.getAttribute("data-variant-id");
    var du = e.target.getAttribute("data-url");
    var variantInfo = e.target.getAttribute("data-varient-da");
    var priceInfo = e.target.getAttribute("data-price");
    e.target.innerHTML = "Removing...";

    window._swat.removeFromWishList(
        {
            "epi": variantId,
            "du": du,
            "empi": productId,
            "pr": priceInfo,
            "variants":variantInfo
        },
        function(r) {
            location.reload();
        }
    );
}


function attachClickListeners(){
    var addToCartButtons = document.getElementsByClassName("add-to-cart");
    for (var i = 0; i < addToCartButtons.length; i++) {
        addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
    }

    var removeWlButtons = document.getElementsByClassName("remove-w-item");
    for (var i = 0; i < removeWlButtons.length; i++) {
        removeWlButtons[i].addEventListener('click', onremoveItemClicked, false);
    }

}

function swymAddMultipleToCartAndRedirect(episOrVariantIds, successCallback, errorCallback) {
    var formData = new FormData();
    episOrVariantIds.forEach(function(epiOrVariantId) {
        formData.append("id[]", epiOrVariantId);
    });
    var request = new XMLHttpRequest();
    request.addEventListener("load", function() {
        if(this.status == 200) {
            window.location = "/cart";
            if(successCallback) successCallback(this);
        } else {
            if(errorCallback) errorCallback(this);
        }
    });
    request.open("POST", "/cart/add");
    request.send(formData);
}